export default __webpack_public_path__ + "static/media/welcome_wave_tablet.4bc4a76c.svg";